//* Libraries imports
import React, { useState } from "react";
import { Search } from "lucide-react";

//* Componentes imports
import { Card, CardContent } from "@/components/ui/card";

export const IAServiceSection = ({ pecas }: { pecas: any[] }) => {
  const [search, setSearch] = useState("");

  return (
    <section className="flex flex-col w-full items-start rounded-xl">
      {/* Header */}
      <Card className="w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">
          <div className="flex w-full h-9 items-center justify-between mb-5">
            <h1 className="text-xl font-bold" id="atividades">
              Serviços de IA (0)
            </h1>
          </div>

          <div className="mb-4 flex w-full" style={{ position: "relative" }}>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="Pesquisar"
              className="p-2 border rounded"
              style={{
                width: "-webkit-fill-available",
                borderRadius: 20,
                paddingLeft: 40,
              }}
            />
            <Search
              style={{
                position: "absolute",
                top: "20%",
                left: 10,
                color: "grey",
              }}
            />
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full ">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4} className="py-4 px-4 text-center">
                    Nenhum serviço de IA vinculado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
